import { render } from "./Secondary4.vue?vue&type=template&id=e2bc58ce&ts=true"
import script from "./Secondary4.vue?vue&type=script&lang=ts"
export * from "./Secondary4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Secondary4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2bc58ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2bc58ce', __exports__)) {
    api.reload('e2bc58ce', __exports__)
  }
  
  module.hot.accept("./Secondary4.vue?vue&type=template&id=e2bc58ce&ts=true", () => {
    api.rerender('e2bc58ce', render)
  })

}


export default __exports__